import { createContext, useState } from "react";

export const InputContext = createContext({
  input: "",
  setInput: () => {},
});

export const InputProvider = ({ children }) => {
  const [input, setInput] = useState("");
  const value = {
    input,
    setInput,
  };
  return (
    <InputContext.Provider value={value}>{children}</InputContext.Provider>
  );
};
